export const PRICE_MODES = ['SIMPLIFIED', 'ADVANCED'] as const;

export type PriceMode = (typeof PRICE_MODES)[number];

type PriceModeConfig = {
  label: string;
  description: string;
  route: string;
};

export const PRICE_MODE_CONFIG: Record<PriceMode, PriceModeConfig> = {
  SIMPLIFIED: {
    label: 'Modo simplificado',
    description:
      'Calculamos o arredondamento pela faixa inteira, seguindo uma lógica aritmética simples e fácil de entender. ' +
      'Suporta até 5 dígitos, o que permite arredondar também valores mais altos.',
    route: '/ipa/preco-psicologico-2',
  },
  ADVANCED: {
    label: 'Modo avançado',
    description:
      'Você define exatamente como arredondar cada faixa decimal, com controle total sobre cada intervalo de preço. ' +
      'O arredondamento funciona somente nas casas decimais.',
    route: '/ipa/preco-psicologico',
  },
};

export const OPPOSITE_PRICE_MODE: Record<PriceMode, PriceMode> = {
  SIMPLIFIED: 'ADVANCED',
  ADVANCED: 'SIMPLIFIED',
};

// Nomes gravados antes da IT-4561; o ipa-setup-engine ainda pode responder com eles até a base ser corrigida.
const LEGACY_PRICE_MODES: Record<string, PriceMode> = {
  NEW: 'SIMPLIFIED',
  OLD: 'ADVANCED',
};

// Cliente que nunca definiu o modo é tratado como Avançado (RN06).
const DEFAULT_PRICE_MODE: PriceMode = 'ADVANCED';

export const BASIC_CONFIG_ROUTE = '/administrador/produtos/IPA/configuracoes-basicas';

export function isPriceMode(value: unknown): value is PriceMode {
  return PRICE_MODES.includes(value as PriceMode);
}

export function normalizePriceMode(value: unknown): PriceMode {
  if (isPriceMode(value)) return value;
  if (typeof value === 'string' && LEGACY_PRICE_MODES[value]) return LEGACY_PRICE_MODES[value];
  return DEFAULT_PRICE_MODE;
}
